import { Mui } from "@osu/react-ui";
import { forwardRef } from "react";

const groupStyles = (theme, hasError) => ({
  borderLeft: `3px solid ${hasError ? theme.palette.error.main : theme.palette.divider}`,
  paddingLeft: theme.spacing(2),
  marginBottom: theme.spacing(3),
  transition: "border-color 0.2s ease",
});

const QuestionGroup = forwardRef(function QuestionGroup({ children, groupId, hasError }, ref) {
  return (
    <Mui.Box ref={ref} sx={(theme) => groupStyles(theme, hasError)}>
      {hasError && (
        <Mui.Alert severity="error" sx={{ mb: 2 }}>
          You must answer "Yes" to at least one of the following questions.
        </Mui.Alert>
      )}
      {children}
    </Mui.Box>
  );
});

export default QuestionGroup;
